  export const securityStock = {
    searchText: 'Buscar entidad',
    addText: 'Crear stock de seguridad',
    export: false,
    filter: false,
    filterDefault: 'TD',
    disabled: false,
    partialField: '',
    columns: [
      {
        title: 'Entidad',
        name: 'entityName',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: any) => element.entityName
      },
      {
        title: 'Concatenación',
        name: 'flatDivision',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'flat',
        value: (element: any) => element.flatDivision
      },
      {
        title: 'Stock de seguridad',
        name: 'quantity',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: any) => element.quantity
      },
      {
        title: 'Listado de productos',
        name: 'view',
        type: 'button',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: any) => {
          return {
            data: element.id,
            icon: 'low_priority',
            tooltip: 'Ver más',
            class: 'recordColumn icon-table'
          };
        }
      },
      {
        title: 'Eliminar',
        name: 'delete',
        type: 'button',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: any) => {
          return {
            data: element.id,
            icon: 'delete',
            tooltip: 'Eliminar',
            class: 'recordColumn icon-table'
          };
        }
      }
    ]
  };
